import { Box } from '@mui/material';
import { VyIcon } from '@weft/icons';

type HomePageEndOfMonthStatIconProps = {
  color: string;
};

export const HomePageEndOfMonthStatIcon: React.FC<HomePageEndOfMonthStatIconProps> = ({ color }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '110px',
        height: '110px',
      }}
    >
      <div
        className='absolute inset-0 z-10 rounded-lg'
        style={{
          background: 'radial-gradient(rgba(255,255 ,255 , 0.90), rgba(255, 255, 255, 0.97), rgba(255, 255, 255, 1))',
        }}
      />
      <VyIcon
        className='absolute inset-0'
        icon='SmallVayu'
        fill={color}
        color='transparent'
      />
    </Box>
  );
};